import { useQuery } from 'react-query';

import { ApplicationSource, Metrics } from '@features/employerMetrics';
import { getSourceApplicationRoute } from '@features/employerMetrics/api/constants';
import axiosInstance from '@server/axiosInstance';

type useGetApplicationSourcesData = {
  status: number;
  message: string;
  objects: ApplicationSource[];
};

type useGetApplicationSourcesProps = {
  selectedDatePeriod?: string;
  selectedCompanyId?: string | number;
};

export const useGetApplicationSources = ({
  selectedDatePeriod,
  selectedCompanyId,
}: useGetApplicationSourcesProps) => {
  const applicationSourcesKey = 'applicationSourcesKey';

  const { data: applicationSources, isLoading: isApplicationSourcesLoading } =
    useQuery<useGetApplicationSourcesData>(
      [applicationSourcesKey, selectedDatePeriod, selectedCompanyId],
      {
        queryFn: () =>
          axiosInstance
            .get(
              `${getSourceApplicationRoute}?time_period=${selectedDatePeriod}` +
                (selectedCompanyId && selectedCompanyId !== 'ALL'
                  ? `&company_id=${selectedCompanyId}`
                  : ''),
            )
            .then((res) => res.data),
        refetchOnWindowFocus: false,
      },
    );

  return {
    applicationSources,
    isApplicationSourcesLoading,
  };
};
